/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuditLogDto } from '../../models/audit-log-dto';
import { AuditLogFilter } from '../../models/audit-log-filter';

export interface AuditLogsPost$Json$Params {
      body?: AuditLogFilter
}

export function auditLogsPost$Json(http: HttpClient, rootUrl: string, params?: AuditLogsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditLogDto>>> {
  const rb = new RequestBuilder(rootUrl, auditLogsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AuditLogDto>>;
    })
  );
}

auditLogsPost$Json.PATH = '/audit/logs';
